import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const FirmwareVariantViewModule = new Module({
  id: 'FIRMWARE-VARIANT:VIEW:RESULT-TABLE',
  name: 'Firmware Variant',
  label: 'Firmware Variant',
  path: 'firmware-variant',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/FirmwareVarient/View'))
  ),
  actions: {
    edit: {
      id: 'FIRMWARE-VARIANT:VIEW:*',
      name: 'VIEW',
      label: 'View'
    }, 
    delete: {
      id: 'firmware-version-delete',
      name: 'delete',
      label: 'Delete'
    }
  }
});

export const FirmwareVariantAddModule = new Module({
  id: 'FIRMWARE-VARIANT:ADD:*',
  name: 'firmwareVariantAdd',
  path: 'firmware-variant/add',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/FirmwareVarient/Form'))
  ),
  actions: {
    add: {
      id: 'FIRMWARE-VARIANT:ADD:*',
      name: 'Firmware Variant Add',
      label: 'Add Firmware Variant'
    }
  }
});

export const FirmwareVariantEditModule = new Module({
  id: 'FIRMWARE-VARIANT:VIEW:DETAILS',
  name: 'Firmware Variant Edit',
  path: 'firmware-variant/details/:firmwareVaritentId',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/FirmwareVarient/Form'))
  )
});

const FirmwareVariantModules = [
  FirmwareVariantViewModule,
  FirmwareVariantAddModule,
  FirmwareVariantEditModule
];

export default new ModuleBundle('FirmwareVariant', FirmwareVariantModules);
